var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;
var CmsUserStore = FuzzyReaction.Stores.CmsUserStore;

var ActionTypes = AppActionConstants.ActionTypes.casts;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for user table data
var _resourceListData = [];
var _exportUrl = '';

/**
 * User store logic
 *
 * @type {*|exports}
 */
var CastStore = assign({}, ModelStore, {
	getResourceListData: function () {
		return _resourceListData;
	},

	getExportUrl: function () {
		// Build an accessible export URL
		return _exportUrl + '&access_token=' + CmsUserStore.getToken();
	}
});

/**
 * Event Listeners
 */
CastStore.dispatchToken = AppDispatcher.register(function(action) {
	switch(action.type) {
		case 'META/STATS_LISTED':
			_resourceListData = action.data.play_counts;
			_exportUrl = action.data.export_url;

			CastStore.emitChange();
			break;
	}
});

module.exports = CastStore;
